import React from 'react';
export function PainPoints() {
  const painCards = [{
    emoji: '😤',
    title: 'La Fatiga del Contenido Invisible',
    desc: 'Horas de esfuerzo, algoritmos ingratos y cero conversión. Los Arquitectos Proxy producen en minutos lo que a otros les toma semanas.',
    quote: '"Regalando mi tiempo al algoritmo desde hace meses."'
  }, {
    emoji: '😰',
    title: 'El Miedo a la Obsolescencia Técnica',
    desc: 'Las herramientas de IA parecen para ingenieros de Silicon Valley. Ese miedo te está costando miles de dólares cada mes.',
    quote: '"La IA avanza y yo me quedo atrás."'
  }, {
    emoji: '😳',
    title: 'La Vergüenza del Diseño Amateur',
    desc: 'Nadie paga $3,000 por una web que parece de 2012. En 20 minutos puedes tener una interfaz que justifica precios premium.',
    quote: '"Me da pena enviar mi portafolio."'
  }];
  return <section className="py-8 md:py-[120px] px-4 md:px-12 relative z-10 bg-gradient-to-b from-transparent via-[rgba(255,59,59,0.02)] to-transparent" aria-label="El dolor del Creador Estancado" data-id="element-209">
      <div className="max-w-[1100px] mx-auto" data-id="element-210">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-start" data-id="element-211">
          {/* LEFT */}
          <div data-id="element-212">
            <h2 className="font-display text-[clamp(2.2rem,5vw,5rem)] leading-none tracking-[2px] mb-4 md:mb-6" data-id="element-213">
              TÚ.
              <br data-id="element-214" />
              <span className="text-accent-red drop-shadow-[0_0_10px_rgba(255,59,59,0.3)]" data-id="element-215">
                ESTÁS
              </span>
              <br data-id="element-216" />
              PERDIENDO
              <br data-id="element-217" />
              EL JUEGO.
            </h2>
            <p className="font-text text-[0.85rem] md:text-[1rem] text-text-silver leading-[1.7] md:leading-[1.8] mb-5 md:mb-8" data-id="element-218">
              El verdadero poder de la IA no es escribir textos, es{' '}
              <strong className="text-white" data-id="element-219">automatizar la riqueza.</strong>{' '}
              Deja de ser el esclavo del algoritmo y conviértete en el dueño del
              sistema. Agencia de un solo hombre, facturación de una
              multinacional.{' '}
              <strong className="text-gold" data-id="element-220">
                Soberanía tecnológica total, sin fronteras.
              </strong>
            </p>
            <ul className="flex flex-col gap-2.5 md:gap-4 mb-5 md:mb-8" data-id="element-221">
              {['Inviertes 5 horas en contenido que genera $0', 'Ves herramientas de IA pero crees que son "para programadores"', 'Tu marca se ve "hecha en casa" y nadie te paga precios premium', '50 pestañas abiertas, 3 cursos sin terminar, 0 ingresos', 'Cobras en pesos cuando deberías cobrar en dólares o euros'].map((item, idx) => <li key={idx} className="flex items-start gap-2.5 text-[0.82rem] md:text-[0.95rem] text-text-silver leading-[1.5]" data-id="element-222">
                  <span className="text-accent-red text-[0.9rem] mt-0.5 shrink-0 drop-shadow-[0_0_6px_rgba(255,59,59,0.4)]" aria-hidden="true" data-id="element-223">
                    ✗
                  </span>
                  {item}
                </li>)}
            </ul>
            <div className="bg-[rgba(255,59,59,0.05)] border border-[rgba(255,59,59,0.15)] border-l-[3px] border-l-accent-red rounded-r-xl p-4 md:p-6 italic text-[0.82rem] md:text-[0.95rem] text-text-silver leading-[1.6]" data-id="element-224">
              "Cada día que pasa sin dominar el Arsenal Proxy es un contrato de
              $2,000 que alguien más está cobrando por ti."
            </div>
          </div>

          {/* RIGHT — Pain Cards */}
          <div className="flex flex-col gap-3 md:gap-4" data-id="element-225">
            {painCards.map((card, idx) => <div key={idx} className="bg-bg-card border border-border rounded-xl p-4 md:p-7 transition-all duration-[350ms] relative overflow-hidden group hover:bg-[rgba(255,59,59,0.04)] hover:border-[rgba(255,59,59,0.2)] hover:-translate-x-1" data-id="element-226">
                <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-accent-red opacity-0 group-hover:opacity-100 transition-opacity duration-300" aria-hidden="true" data-id="element-227" />
                <span className="text-[1.4rem] md:text-[1.75rem] block mb-2" aria-hidden="true" data-id="element-228">
                  {card.emoji}
                </span>
                <h3 className="font-body text-[0.88rem] md:text-[0.95rem] font-bold text-white mb-1.5" data-id="element-229">
                  {card.title}
                </h3>
                <p className="text-[0.78rem] md:text-[0.85rem] text-text-muted leading-[1.5] mb-2" data-id="element-230">
                  {card.desc}
                </p>
                <p className="text-[0.75rem] md:text-[0.8rem] text-[rgba(255,59,59,0.8)] italic" data-id="element-231">
                  {card.quote}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}